export const theme = {
  palette: {
    themePrimary: '#003da5',
    themeDarkAlt: '#003da5',
    alert: '#dc1c2e',
  },
  fonts: {
    tiny: { fontSize: '10px' },
    xSmall: { fontSize: '11px' },
    small: { fontSize: '12px' },
    smallPlus: { fontSize: '14px' },
    medium: { fontSize: '16px' },
    mediumPlus: { fontSize: '18px' },
    large: { fontSize: '20px' },
    xLarge: { fontSize: '22px' },
  },
};



// WEBPACK FOOTER //
// ./src/app/@remax-at/theme.js